import React, { useState } from 'react';
import { StoryWrapper } from '../StoryWrapper';
import PleasantnessLineChart from '../../insights/PleasantnessLineChart';
import { FlowDetails } from '../FlowDetails';
import styles from '../week-reflection.module.css';

const chartLineColor = '#C5EBD4';

export const PeakValley = ({ story, action, isPaused, config, storyData }) => {
    const [animateCurve, setAnimateCurve] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const getButtonText = (data) => {
        const peakText = data.peakIndices?.length > 0 ?
            (data.peakIndices.length === 1 ? 'peak' : 'peaks')
            : '';
        const valleyText = data.valleyIndices?.length > 0 ?
            (data.valleyIndices.length === 1 ? 'valley' : 'valleys')
            : '';

        if (peakText && valleyText) {
            return `See ${peakText} and ${valleyText}`;
        }
        else {
            return `See ${peakText}${valleyText}`;
        }
    }

    const showFlows = () => {
        // pause the story. Doing it via setTimeout because directly doing pause has not consistently worked
        setTimeout(() => {
            action('pause');
        }, 10);
        setAnimateCurve(false);
        setShowModal(true);
    }

    const exitModal = () => {
        setShowModal(false);
        action('play');
    }

    return (
        !showModal ?
            <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
                <div style={{ margin: "2rem 0.5rem" }}>
                    <p>
                        {storyData.data.trend ? storyData.data.trend // updated gpt description
                            : Array.isArray(storyData.data.description) ?
                                <>You had {storyData.data.description.map((item, index) =>
                                    item.style === "bold" ? (
                                        <span style={{ fontWeight: 600 }} key={index}>{item.text}</span>
                                    ) : item.text
                                )}
                                </>
                                :
                                storyData.data.description // placeholder description
                        }
                    </p>
                </div>
                <PleasantnessLineChart data={storyData.data} lineColor={chartLineColor} animate={animateCurve} />
                {storyData.data?.sortedPeakAndValleyFlows?.length > 0 &&
                    <button className={styles.showFlowButton}
                        onClick={showFlows} style={{ zIndex: 1000 }}>
                        {getButtonText(storyData.data)}
                    </button>
                }
            </StoryWrapper>
            : <FlowDetails flows={storyData.data.sortedPeakAndValleyFlows} close={exitModal} />
    )
};